import React, { useRef, useEffect } from 'react';

const LocationInfoOverlay = ({ isOpen, onClose }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    if (isOpen && cardRef.current) {
      const header = document.querySelector('header');
      if (header) {
        const inputContainer = header.querySelector('div[class*="rounded"]');
        if (inputContainer) {
          const inputRect = inputContainer.getBoundingClientRect();
          cardRef.current.style.top = `${inputRect.top + inputRect.height / 2}px`;
          cardRef.current.style.borderTopLeftRadius = inputContainer.style.borderTopLeftRadius;
          cardRef.current.style.borderTopRightRadius = inputContainer.style.borderTopRightRadius;
        }
      }
      requestAnimationFrame(() => {
        cardRef.current.classList.remove('opacity-0', '-translate-y-4');
        cardRef.current.classList.add('opacity-100', 'translate-y-0');
      });
    }
  }, [isOpen]);

  const handleOverlayClick = (e) => {
    e.stopPropagation();
    onClose();
  };

  const handleCardClick = (e) => {
    e.stopPropagation();
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed bg-black bg-opacity-60 z-40"
        style={{
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }}
        onClick={handleOverlayClick}
      />

      <div
        ref={cardRef}
        className="fixed bg-white rounded-b-lg shadow-xl transform transition-all duration-300 ease-out opacity-0 -translate-y-4 z-40"
        style={{
          width: 'calc(100vw/12*10)',
          left: 'calc(100vw/12)',
        }}
        onClick={handleCardClick}
      >
        <div className="h-[calc(100svh/72*2)] opacity-0" />
        <div className="p-6">
          <p className="text-gray-700 leading-relaxed">
            エレベータ内に貼られているラベル記載の
            <span className="font-bold ux-text-red">7桁の登録番号(ハイフンなし)</span>
            を入力ください。ラベルがない場合、エレベータの所有者・管理者にお問い合わせください。
          </p>
        </div>
        <img
          src="./assets/static/LE.png"
          className="w-[calc(100vw/12*8)] h-auto object-cover rounded-b-lg mx-auto mb-6"
          alt="エレベータラベル例"
        />
      </div>
    </>
  );
};

export default LocationInfoOverlay;